module.exports = __webpack_public_path__ + "static/media/ccMap.f520edbc.jpg";